import { createAction } from "@reduxjs/toolkit";
import { securedFetch } from "../../auth/authService";
import { NMAP_INVENTORY_API } from "../../vars";
import {getSortAndFilterQueryString} from "../../view/urlService";
import store from "../../app/store";


import { ACTION_INVENTORY_CHANGED } from "./InventoryPageReducer";

export function getInventoryList() {
    return securedFetch(NMAP_INVENTORY_API)
        .then(response => response.json())
        .then(data => {
            store.dispatch(createAction(ACTION_INVENTORY_CHANGED)({ inventoryList: data }));
            return data;
        });
}

export async function listPageable(pageNumber, pageSize) {

    const queryString = getSortAndFilterQueryString(pageNumber, pageSize);

    return await securedFetch(`${NMAP_INVENTORY_API}/page?${queryString}`)
    .then(response => response.json())
    .then(data => {
        store.dispatch(createAction(ACTION_INVENTORY_CHANGED)({inventoryList: data.page}));
        return {users: data.page, totalPages: data.total, totalRecords: data.records}
    });

}

export function startNmapInventoryScan (command) {
    return securedFetch(`${NMAP_INVENTORY_API}?command=${command}`, 
                null, 
                'POST')
        .then(response => response.json())     
}

//Check if the command is not changed by the user
export async function validateCommandNotChanged(command) {
    // Regular expression to check if the command starts with "nmap -O" and follows with a valid IP or subnet
    //const regex = /^nmap\s+-O\s+(\d{1,3}\.){3}\d{1,3}(\/\d{1,2})?$/;
    //const regex = /^nmap\s+-O\s+(\d{1,3}\.){3}\d{1,3}(\/(3[0-2]|[1-2]?[0-9]))$/;
    const regex = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\/(3[0-2]|[12]?[0-9]))$/;
    return regex.test(command);
  };


// Call API to update Discovered Host OS
export async function updateOS(id, os){
    return await securedFetch(`${NMAP_INVENTORY_API}/update-os?id=${id}`,
                                {os:os}, 'POST')
        .then((response)=>{
            if(response.ok){
                const inventory=response.json();
                return inventory;
            }
        });   
}

// export async function getScanOutputbyId(id) {
//    try {
//         const response = await securedFetch(`${NMAP_SCAN_API}/${id}`);
//         if (response.ok) {
//             const jsonResponse = await response.text();
//             return jsonResponse;
//         }
//         return "";
//    } catch (error) {
//         console.error("Error loading Nmap Scan Output:", error);
//         return "";
//     }
// }


